import React from "react";

import BrandLogo from "./BrandLogo";

function AuthLayout({ headerLink, children }) {
  const year = new Date().getFullYear();

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <header className="flex items-center justify-between px-6 py-8 md:px-16">
        <BrandLogo />
        {headerLink && (
          <div className="text-right font-josefin text-sm text-secondaryText">
            {headerLink}
          </div>
        )}
      </header>

      <main className="flex flex-1 flex-col items-center justify-center px-6 pb-10">
        <div className="flex w-full max-w-md flex-col gap-6">{children}</div>
      </main>

      <footer className="py-8 text-center font-josefin text-sm text-grey">
        © {year} ByeByeRegrets
      </footer>
    </div>
  );
}

export default AuthLayout;
